/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConfidenceEnum } from './ConfidenceEnum';
import { ConfidenceEnumFromJSON, ConfidenceEnumFromJSONTyped, ConfidenceEnumToJSON } from './ConfidenceEnum';

/**
 * Suggestion produced by the AI questionnaire prefill agent.
 * @export
 * @interface PrefillResponse
 */
export interface PrefillResponse {
  /**
   * The suggested answer. For radio/dropdown one of the provided options (exact text); conflicting values are joined with ' | '. For free_text prose. Empty for multi_select — read `selected_options` instead. 'No prior data available.' when nothing relevant was found.
   * @type {string}
   * @memberof PrefillResponse
   */
  answer: string;
  /**
   * For multi_select: the selected options as a list of exact option texts (the union of options on a conflict). Empty for other question types and when no relevant data was found.
   * @type {Array<string>}
   * @memberof PrefillResponse
   */
  selectedOptions: Array<string>;
  /**
   *
   * @type {ConfidenceEnum}
   * @memberof PrefillResponse
   */
  confidence: ConfidenceEnum;
  /**
   *
   * @type {string}
   * @memberof PrefillResponse
   */
  explanation: string;
}

/**
 * Check if a given object implements the PrefillResponse interface.
 */
export function instanceOfPrefillResponse(value: object): value is PrefillResponse {
  if (!('answer' in value) || value['answer'] === undefined) return false;
  if (!('selectedOptions' in value) || value['selectedOptions'] === undefined) return false;
  if (!('confidence' in value) || value['confidence'] === undefined) return false;
  if (!('explanation' in value) || value['explanation'] === undefined) return false;
  return true;
}

export function PrefillResponseFromJSON(json: any): PrefillResponse {
  return PrefillResponseFromJSONTyped(json, false);
}

export function PrefillResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrefillResponse {
  if (json == null) {
    return json;
  }
  return {
    answer: json['answer'],
    selectedOptions: json['selected_options'],
    confidence: ConfidenceEnumFromJSON(json['confidence']),
    explanation: json['explanation'],
  };
}

export function PrefillResponseToJSON(value?: PrefillResponse | null): any {
  if (value == null) {
    return value;
  }
  return {
    answer: value['answer'],
    selected_options: value['selectedOptions'],
    confidence: ConfidenceEnumToJSON(value['confidence']),
    explanation: value['explanation'],
  };
}
